import Vue from 'vue'
import VueIdb from 'vue-idb'

Vue.use(VueIdb)

export default new VueIdb({
    version: 1,
    database: 'pso2ac',
    schemas: [
        { working: '++id, abilities' },
        { history: '++id, title, abilities, created_at, updated_at' }
    ]
})
